import { useRecoilValue } from 'recoil';
import { frontendSettingsAtom } from '../../../atoms/FrontendSettings';

export const useThemeColor = () => {
  const settings = useRecoilValue(frontendSettingsAtom);

  return {
    primary: settings.settingsV1.storefront_primary_color || '#e95f42',
    secondary: settings.settingsV1.storefront_secondary_color || '#ffffff',
    ternary: settings.settingsV1.storefront_ternary_color || '#000000',
  };
};
